import { useEffect } from 'react';

const useHideScrollBar = (active = true) => {
  useEffect(
    () => {
      document.body.style.overflow = active ? 'hidden' : 'auto';
      return () => {
        document.body.style.overflow = 'auto';
      };
    },
    [active],
  );
};

export default useHideScrollBar;
